import { render, staticRenderFns } from "./ChatInterface.vue?vue&type=template&id=588aaddc&scoped=true&"
import script from "./ChatInterface.vue?vue&type=script&lang=js&"
export * from "./ChatInterface.vue?vue&type=script&lang=js&"
import style0 from "./ChatInterface.vue?vue&type=style&index=0&id=588aaddc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588aaddc",
  null
  
)

export default component.exports